// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AixIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 34.66 13.79">
    <defs>
      <linearGradient
        id="aix_svga"
        x1={0.15}
        x2={0.55}
        y1={-0.59}
        y2={-0.4}
        gradientTransform="scale(99.2)rotate(-45 .97 -.05)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#6fdc8c" />
        <stop offset={0.3} stopColor="#6fdc8c" />
        <stop offset={0.93} stopColor="#009d9a" />
        <stop offset={1} stopColor="#009d9a" />
      </linearGradient>
    </defs>
    <g
      fill="url(#aix_svga)"
      strokeWidth={0.74}
      transform="matrix(.9808 0 0 .9924 -.92 -.98)"
    >
      <path d="m10.91 14.79-.98-3.26H5.35l-.98 3.26H1.34L5.86 1.08h3.7L14 14.79zm-3.24-11h-.1l-1.51 5.2H9.2zM15.39 14.79v-2.38h1.77V3.45h-1.77V1.08h6.52v2.37h-1.77v8.96h1.77v2.38zM35.8 14.79h-3.46l-2.97-5.05h-.05l-2.9 5.05h-3.21l4.4-7.1-4.19-6.61h3.48l2.67 4.63h.06l2.71-4.63h3.22l-4.22 6.68z" />
    </g>
  </svg>,
  "Aix",
);
export default AixIcon;
